import { useEsigningSettings } from 'app/domains/esigning/hooks/useEsigningSettings';
import { SignatoryStatus } from 'shared/domains/apollo/generated/types';
import { RecipientItem } from '../../../../RecipientItem';
import { PendingActions } from '../PendingActions';
const NO_ACTIONS_STATUSES = [SignatoryStatus.Signed, SignatoryStatus.Rejected];
export function PendingRecipient(props) {
    const { recipient, isOnlyRecipient } = props;
    const { status } = recipient;
    const { groupMessage } = useEsigningSettings();
    if (!status) {
        return null;
    }
    const hideActions = NO_ACTIONS_STATUSES.includes(status);
    return (<RecipientItem recipient={recipient} groupMessage={groupMessage} endElement={!hideActions && <PendingActions recipient={recipient} isOnlyRecipient={isOnlyRecipient}/>}/>);
}
